import { useEffect, useState } from 'react';
import { Banner, Text } from '@shopify/polaris';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import agent from '../../app/api/agent';

export default observer(function PilotOperatorBanner() {
  const { userStore } = useStore();
  const session = userStore.user?.impersonation;
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!session) return;
    const timer = window.setTimeout(() => { userStore.logout(); window.location.replace('/pf-console/stores'); },
      Math.max(0, Date.parse(session.expiresUtc) - Date.now()));
    return () => window.clearTimeout(timer);
  }, [session, userStore]);
  if (!session) return null;
  const end = async () => {
    setBusy(true); setError('');
    try {
      await agent.Account.endImpersonation();
      userStore.logout(); window.location.replace('/pf-console/stores');
    } catch { setError('Unable to confirm session termination. Retry; the session will expire at the time shown.'); }
    finally { setBusy(false); }
  };
  return <Banner tone="warning" title={`Impersonating ${userStore.user?.shopDomain}`}
    action={{ content: busy ? 'Ending…' : 'Exit impersonation', onAction: () => void end(), disabled: busy }}>
    <Text as="p">Operator: {session.operatorEmail}. Changes affect this live store and are audited. Session expires {new Date(session.expiresUtc).toLocaleTimeString()}.</Text>
    {error && <Text as="p" tone="critical">{error}</Text>}
  </Banner>;
});
